<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <uilab-mat-form-field [appearance]="example.appearance">
            <uilab-mat-label>Label</uilab-mat-label>
            <input
                uilabMatInput
                type="text"
                [attr.aria-label]="
                    example.variant === 'filled'
                        ? 'Filled text field'
                        : 'Outlined text field'
                "
            />
        </uilab-mat-form-field>
    </avd-code-example>
}
